export default "__VITE_ASSET__4400d687__"